import {createBrowserRouter, Navigate, Outlet} from 'react-router';
import {useMemo} from 'react';
import {Maybe, User} from '@cp/model';
import ErrorPage from '../pages/other/ErrorPage';
import LoginPage from '../pages/login/LoginPage';
import AdminLayout from '../router/AdminLayout';
import AppLayout from '../router/AppLayout';
import BranchRoute from '../router/BranchRoute';
import mapRouteTypeToRoute from './mapRouteTypeToRoute';
import {routeAdmin} from './routeAdmin';
import {routeChecks} from './routeChecks';
import {routeFeatures} from './routeFeatures';
import {routeSettings} from './routeSettings';

export function buildRoute(user: Maybe<User> | undefined) {
  return createBrowserRouter([
    // login route
    // {
    //   path: '/login',
    //   loader: () => ({}),
    //   element: (
    //     <BranchRoute user={user} userUndefinedLoading privateRoute={<Navigate to="/" />} publicRoute={<LoginPage />} />
    //   ),
    // },
    // internal routes
    {
      element: (
        <AppLayout user={user}>
          <Outlet />
        </AppLayout>
      ),
      errorElement: (
        <AppLayout user={user}>
          <ErrorPage />
        </AppLayout>
      ),
      loader: () => ({}),
      children: [
        {
          element: (
            <BranchRoute user={user} userUndefinedLoading privateRoute={<Outlet />} publicRoute={<LoginPage />} />
          ),
          loader: () => ({}),
          children: [
            ...routeFeatures(user).map((feature) => mapRouteTypeToRoute(feature, {user: user as User})),
            ...routeSettings().map((setting) => mapRouteTypeToRoute(setting, {user: user as User})),
            // Admin routes section
            {
              path: '/admin',
              element: (
                <AdminLayout user={user as User}>
                  <Outlet />
                </AdminLayout>
              ),
              loader: () => ({}),
              children: routeAdmin(user).map((route) => mapRouteTypeToRoute(route, {user: user as User})),
            },
          ],
        },
      ],
    },
    ...routeChecks().map((check) => mapRouteTypeToRoute(check)),
    // landing page - redirect to login if not authenticated, to exercise if authenticated
    // {
    //   path: '/',
    //   loader: () => ({}),
    //   element: <BranchRoute user={user} privateRoute={<Navigate to="/" />} publicRoute={<LoginPage />} />,
    // },

    {
      path: '*',
      loader: () => ({}),
      element: <BranchRoute user={user} privateRoute={<Navigate to="/" />} publicRoute={<LoginPage />} />,
    },
  ]);
}

// Memoized version to prevent route recreation
export function useBuildRoute(user: Maybe<User> | undefined) {
  return useMemo(
    () => buildRoute(user),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user?.id, user === null, user === undefined, JSON.stringify(user)],
  );
}
